const SortType = Object.freeze({
  ALPHABETICAL: 'alphabetical',
  BOOLEAN: 'boolean',
  NUMERIC: 'numeric',
  PROPERTY: 'property',
  SELECTION: 'selection',
  TAG: 'tag',
});

export default SortType;
